import React from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

function HomePage({ user, logout }) {
  const history = useHistory();

  console.log('HomePage rendered, user:', user);

  const handleLogout = () => {
    logout();
    history.push('/login');
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar style={{ backgroundColor: '#3498db', color: '#ffffff' }}>
          <IonTitle>Home</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent style={{ backgroundColor: '#ffffff' }}>
        <h1 style={{ color: '#2ecc71' }}>Welcome {user ? user.username : 'Guest'}</h1>
        {user && <IonButton onClick={handleLogout}>Logout</IonButton>}
        <IonButton onClick={() => history.push('/add-tree')}>Add Tree</IonButton>
        {user && user.is_admin && <IonButton onClick={() => history.push('/admin')}>Admin Dashboard</IonButton>}
      </IonContent>
    </IonPage>
  );
}

HomePage.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
    is_admin: PropTypes.bool
  }),
  logout: PropTypes.func.isRequired
};

export default HomePage;